import script from "./PropertySpecialismDropDownModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./PropertySpecialismDropDownModal.vue?vue&type=script&lang=ts&setup=true"

import "./PropertySpecialismDropDownModal.vue?vue&type=style&index=0&id=38316c2a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-38316c2a"]])

export default __exports__